const THREE = require('three')
window.THREE = THREE
// require('three/examples/js/postprocessing/EffectComposer')
// require('three/examples/js/postprocessing/RenderPass')
// require('three/examples/js/postprocessing/MaskPass')
// require('three/examples/js/postprocessing/ShaderPass')
// require('three/examples/js/postprocessing/UnrealBloomPass')
// require('three/examples/js/postprocessing/BokehPass')

// require('three/examples/js/shaders/BokehShader')
// require('three/examples/js/shaders/CopyShader')
// require('three/examples/js/shaders/ConvolutionShader')
// require('three/examples/js/shaders/LuminosityHighPassShader')

import Stats from 'stats.js'
import store from 'src/store'
import scene from './scene'
import raf from './raf'
import config from './config'
import camera from './camera'
// import * as perf from './performance'

import {camera as uiCamera} from './camera-ui'
import {scene as resultScene} from './result/scene'
import {scene as uiScene} from './ui/scene'

let base = require('src/../config').build.assetsPublicPath
import Wagner from 'src/lib/Wagner-master/Wagner'
import 'src/lib/Wagner-master/Wagner.base'

// let camera
// if (config.debugCamera) {
//   camera = require('./camera-debug').default
// } else {
//   camera = require('./camera').default
// }
// console.log(111, camera)

// **************************************************
//
// STATS
//
// **************************************************
export let stats = new Stats()
stats.setMode(0) // 0: fps, 1: ms, 2: mb
stats.domElement.id = 'stats'



// **************************************************
//
// RENDERER
//
// **************************************************
export let renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
  premultipliedAlpha: true
})
renderer.setSize(window.innerWidth, window.innerHeight)
renderer.autoClear = false
// renderer.setPixelRatio(1.5)

let ratio = config.pixelRatio.start
// if (!store.state.browser.isIOS) ratio = 0.75
ratio = Math.min(ratio, window.devicePixelRatio)
renderer.setPixelRatio(ratio)
renderer.setClearColor(0x0A0722, 0)
renderer.shadowMap.enabled = true
// renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.gammaInput = false
renderer.gammaOutput = false

export const maxAnisotropy = renderer.getMaxAnisotropy()

// **************************************************
//
// WAGNER COMPOSER
//
// **************************************************

// PATHS
window.WAGNER.vertexShadersPath = `${base}static/Wagner-master/vertex-shaders`
window.WAGNER.fragmentShadersPath = `${base}static/Wagner-master/fragment-shaders`
window.WAGNER.assetsPath = `${base}static/Wagner-master/assets`

// COMPOSER
export let composerw = new window.WAGNER.Composer( renderer )
composerw.setSize(
  ratio * window.innerWidth,
  ratio * window.innerHeight
)

// BLOOM
export let multiPassBloomPass = new window.WAGNER.MultiPassBloomPass(
  // ratio * composerw.width,
  // ratio * composerw.height
)
multiPassBloomPass.params.blurAmount = 0
multiPassBloomPass.params.useTexture = false
multiPassBloomPass.params.blendMode = window.WAGNER.BlendMode.Screen

// ZOOM BLUR
export let zoomBlurPass = new window.WAGNER.ZoomBlurPass()
zoomBlurPass.params.center.set(
  0.5 * composerw.width,
  0.5 * composerw.height
)
zoomBlurPass.params.strength = 0

// NOISE
export let noisePass = new window.WAGNER.NoisePass()
noisePass.params.amount = 0.05
noisePass.params.speed = 0.3

// VIGNETTE
export let vignettePass = new window.WAGNER.VignettePass()
vignettePass.params.amount = 0.4
vignettePass.params.falloff = 0.1

// CHROMATIC ABERATION
export let chromaticAberrationPass = new window.WAGNER.ChromaticAberrationPass()

// BOX (x for unfocus)
export let boxBlurPass = new window.WAGNER.BoxBlurPass()
boxBlurPass.params.delta = new THREE.Vector2(100, 0)
boxBlurPass.params.taps = 1

export let brightnessPass = new window.WAGNER.BrightnessContrastPass()
brightnessPass.params.brightness = -0.14

export let passes = [
  multiPassBloomPass,
  zoomBlurPass,
  boxBlurPass,
  brightnessPass
  // noisePass,
  // vignettePass
]

for (let pass of passes) {
  pass.enabled = true
}
// multiPassBloomPass.enabled = false








// **************************************************
//
// NORMAL COMPOSER
//
// **************************************************
// export let composer = new THREE.EffectComposer(renderer)
// export let renderPass = new THREE.RenderPass(scene, camera)
// renderPass.enabled = true
// composer.addPass(renderPass)

// export let bloom = new THREE.UnrealBloomPass(
//   {
//     x: window.innerWidth,
//     y: window.innerHeight
//   },
//   1.0, // STRENGTH
//   0.2, // RADIUS
//   0.38 // THRESHOLD
// )
// composer.addPass(bloom)

// let copyShader = new THREE.ShaderPass(THREE.CopyShader)
// copyShader.renderToScreen = true
// composer.addPass(copyShader)




// **************************************************
//
// RESIZE
//
// **************************************************
const updateSize = function () {

  const w = store.state.browser.windowWidth
  const h = store.state.browser.windowHeight

  // RENDERER
  renderer.setSize(w, h)

  // COMPOSER
  composerw.setSize(w * ratio, h * ratio)
  zoomBlurPass.params.center.set(w / 2, h / 2)

}

store.watch(function (state) {
  return store.state.browser.windowWidth
}, updateSize)

store.watch(function (state) {
  return store.state.browser.windowHeight
}, updateSize)


export let renderGame = false
export let renderResults = false

export const setRenderGame = function (shouldRender) {
  renderGame = shouldRender
}
export const setRenderResults = function (shouldRender) {
  renderResults = shouldRender
}

// **************************************************
//
// UPDATE
//
// **************************************************
function update (delta) {

  stats.begin()

  if (renderGame) {

    // GAME
    renderer.autoClearColor = true
    composerw.reset()
    composerw.render( scene, camera )
    for (let pass of passes) {
      if (pass.enabled) composerw.pass(pass)
    }
    composerw.toScreen()
    // renderer.render(scene, camera)

    // UI
    renderer.clearDepth()
    renderer.render(uiScene, uiCamera)
  }

  if (renderResults) {
    renderer.clearDepth()
    renderer.render(resultScene, uiCamera)
  }

  stats.end()

}
raf.on('tick', update)
export default renderer




// **************************************************
//
// PERFORMANCE
//
// **************************************************
// config.pixelRatio.max = Math.min(window.devicePixelRatio, config.pixelRatio.max)
// export let currRatio = config.pixelRatio.start
// export let fps = 0
// console.warn = ()=> {}
// perf.ticker.on('data', function(framerate) {

//   console.log('framerate', framerate)

//   fps = framerate
//   let toRatio
//   if (framerate >= config.pixelRatio.targetFps) {
//     toRatio = currRatio + config.pixelRatio.step
//   } else {
//     toRatio = currRatio - config.pixelRatio.step
//     config.pixelRatio.max = toRatio
//   }
//   toRatio = Math.min(toRatio, config.pixelRatio.max)
//   toRatio = Math.max(toRatio, config.pixelRatio.min)
//   if (toRatio !== currRatio) {
//     currRatio = toRatio
//     renderer.setPixelRatio(currRatio)
//     console.log(`Set Pixel Ratio to ${currRatio}`, framerate)
//   }
//   if (config.pixelRatio.min === config.pixelRatio.max) {
//     perf.stop()
//   }
// })
// if (config.pixelRatio.auto) perf.start()





// **************************************************
//
// HOT MODULE REPLACEMENT
//
// **************************************************
if (module.hot) {
  module.hot.accept()
  module.hot.dispose(function() {
    raf.stop()
  })
}



// WEBPACK FOOTER //
// ./src/components/game/renderer.js